'use client';

import type { StaticSectionsProps } from './data';

import { Breadcrumb, Container, PublicPageHeading } from '@/components';
import { useTranslation } from '@/hooks';
import { routes } from '@/statics';

const StaticSections: StaticSectionsProps = ({ subCategoryData }) => {
  const { t } = useTranslation('pages');

  return (
    <>
      {subCategoryData && (
        <>
          <Container gap={{ base: 2.5, md: 5 }}>
            <Breadcrumb
              list={[
                { title: t('home.home'), href: routes.home.url },
                {
                  title: routes.categories.title,
                  href: routes.categories.url,
                },
                {
                  title: subCategoryData.parent.title,
                  href: routes.category.href(subCategoryData.parent.code),
                },
                {
                  title: subCategoryData?.title,
                  href: routes.category.href(subCategoryData?.code),
                },
              ]}
            />
          </Container>
          <PublicPageHeading title={subCategoryData?.title} />
        </>
      )}
    </>
  );
};
export default StaticSections;
